import immutableUpdate from 'immutable-update'
import React, {
  useEffect,
  useReducer
} from 'react'
import { 
  AnimatePresence,
  motion
} from 'motion/react'
import * as PIXI_SOUND from '@pixi/sound';
import data from './data'
import Cover from './cover'
import Question from './question'

import correct from 'assets/audio/uam/unlocked-short.mp3'
import incorrect from 'assets/audio/uam/fail.mp3'

export const QuizAnimated = props => {

  const [ state, dispatch ] = useReducer(
    (state, action) => {

      switch(action.type) {

        default: 

          const newState = immutableUpdate(
            state,
            action
          )

          return newState
      }
    },
    {
      play: true,
      question: data.pregunta,
      answers: data.opciones,
      selectedAnswerId: null,
      correct: false,
      showcorrect: false,
      correctsound: null,
      incorrectsound: null,
      inexit: false
    }
  )
  
  useEffect(() => {

    PIXI_SOUND.Sound.from({
      url: correct,
      preload: true,
      loaded: (err, sound) => {

        dispatch({
          correctsound: sound
        })
      }
    });

    PIXI_SOUND.Sound.from({
      url: incorrect,
      preload: true,
      loaded: function(err, sound) {

        dispatch({
          incorrectsound: sound
        })
      }
    });


  }, [])
  
  return <div 
    className={`
      quizanimated
      ${ state.inexit ? 'inexit' : '' }
    `}
  >
    <AnimatePresence
      onExitComplete={ 
        () => dispatch({
          inexit: false
        }) 
      }
    >
      {
        !state.play &&
        <motion.div 
          className="coverwrapper"
          key="cover"
          exit={{ 
            opacity: 0,
            y: -200,            
            transition: {
              duration: 0.8
            }
          }}          
        >
            <Cover 
              state={ state }     
              dispatch={ dispatch }
            />
        </motion.div>
      }
    </AnimatePresence>
    {
      (
        state.play
        &&
        !state.inexit 
      ) &&
      <Question 
        state={ state }     
        dispatch={ dispatch }       
      />
    }
  </div>
}
